import type { FunctionComponent } from 'react';
import useIndicator from './useIndicator';

interface IndicatorProps {
  isActive: boolean;
}

const Indicator: FunctionComponent<IndicatorProps> = function ({ isActive }) {
  const classNames = useIndicator(isActive);
  return (
    <div className={classNames.container}>
      <div className={classNames.tick} />
    </div>
  );
};

Indicator.displayName = 'CreditLines-CreditLine-Indicator-view';

export default Indicator;
